import * as React from 'react';
import { useSearch } from '../hooks';

interface ISearchInput {
  placeholder?: string;
}

const SearchInput: React.FC<ISearchInput> = ({ placeholder }) => {
  const {
    state: { query },
    updateQuery
  } = useSearch();
  const [search, setSearch] = React.useState(query);

  const handleSubmint = React.useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (search) {
        updateQuery(search);
      }
    },
    [search]
  );

  return (
    <form className="search__input" onSubmit={handleSubmint}>
      <input
        type="text"
        placeholder={placeholder}
        className="search__input-field"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      {search && (
        <button
          type="button"
          aria-label="Clear"
          className="search__input-clear"
          onClick={() => setSearch('')}
        >
          <svg role="presentation">
            <use xlinkHref="#close" />
          </svg>
        </button>
      )}
    </form>
  );
};

export default SearchInput;
